import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../utils/contactInfo';
import styles from '../Auth/Auth.module.scss';
import { StaticPageLayout } from '../StaticPages/StaticPageLayout';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setIsSubmitting(true);

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/update-password`,
      });

      if (resetError) {
        setError(resetError.message);
      } else {
        setMessage(
          "If an account exists for that email, we've sent a password reset link. Check your inbox.",
        );
      }
    } catch {
      setError('An unexpected error occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StaticPageLayout title="Reset Password">
      <div className={styles.authContainer} style={{ minHeight: 'auto', background: 'transparent' }}>
        <div
          className={styles.card}
          style={{ maxWidth: '400px', margin: '0 auto', border: 'none', boxShadow: 'none', background: 'transparent' }}
        >
          <p className={styles.subText}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          {message && (
            <div
              className={styles.error}
              role="status"
              aria-live="polite"
              style={{
                background: 'rgba(16, 185, 129, 0.1)',
                borderColor: 'rgba(16, 185, 129, 0.2)',
                color: '#059669',
              }}
            >
              {message}
            </div>
          )}

          {error && (
            <div className={styles.error} role="alert" aria-live="polite">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className={styles.form} noValidate>
            <div className={styles.inputGroup}>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                autoComplete="email"
                inputMode="email"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
              />
            </div>

            <button type="submit" className={styles.button} disabled={isSubmitting}>
              {isSubmitting ? 'Sending Link…' : 'Send Reset Link'}
            </button>
          </form>

          <div className={styles.link}>
            <Link to="/login">Back to Login</Link>
          </div>
          <div className={styles.link} style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
            Need help? <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
          </div>
        </div>
      </div>
    </StaticPageLayout>
  );
};
